import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import SettingsApiService from './_services/settings.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    settings: [],
  },
  mutations: {
    [MutationTypes.SET_SETTINGS](state, payload) {
      state.settings = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_SETTINGS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix },
    ) {
      commit(MutationTypes.SET_SETTINGS, await SettingsApiService.getSettings({ suffix }));
    },
  },
};
